import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import HowItWorksPage from './pages/HowItWorksPage';
import ShopPage from './pages/ShopPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PartnerPage from './pages/PartnerPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import PartnerLoginPage from './pages/PartnerLoginPage';
import PartnerSignupPage from './pages/PartnerSignupPage';
import DashboardPage from './pages/DashboardPage';
import PartnerDashboardPage from './pages/PartnerDashboardPage';
import ScanPage from './pages/ScanPage';
import ActivateTagPage from './pages/ActivateTagPage';
import TagPublicPage from './pages/TagPublicPage';
import AdminQRPage from './pages/AdminQRPage';
import FAQPage from './pages/FAQPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ProfilePage from './pages/ProfilePage';
import TrackOrderPage from './pages/TrackOrderPage';
import { Toaster } from './components/ui/toaster';
import { AuthProvider, useAuth } from './context/AuthContext';

function Protected({ children, role }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to={role === 'partner' ? '/partner/login' : role === 'admin' ? '/admin/login' : '/login'} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/refund" element={<RefundPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/partner/login" element={<PartnerLoginPage />} />
            <Route path="/partner/signup" element={<PartnerSignupPage />} />
            <Route path="/dashboard" element={<Protected role="customer"><DashboardPage /></Protected>} />
            <Route path="/partner/dashboard" element={<Protected role="partner"><PartnerDashboardPage /></Protected>} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<Protected role="admin"><AdminDashboardPage /></Protected>} />
            <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/track/:orderNumber" element={<TrackOrderPage />} />
            <Route path="/scan/:tagId" element={<ScanPage />} />
            <Route path="/activate" element={<ActivateTagPage />} />
            <Route path="/tag/:slug" element={<TagPublicPage />} />
            <Route path="/tag/:slug/*" element={<TagPublicPage />} />
            <Route path="/admin/qr" element={<Protected role="admin"><AdminQRPage /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
